// src/features/manual/i18n/en.ts

export default {
  name: 'User manual',
  title: 'User manual',
  parts: {
    'getting-started': 'Getting started',
    reception: 'Reception',
    management: 'Management',
    finance: 'Finance',
    incidents: 'Incidents',
    systems: 'Systems',
    administration: 'Administration',
    reference: 'Reference',
    other: 'Other',
  },
  rail: {
    label: 'Manual contents',
    toggle: 'Manual contents',
    inChapter: 'In this chapter',
  },
  search: {
    label: 'Search the manual',
    placeholder: 'Search the manual',
    clear: 'Clear the search',
    results: 'Search results',
    tooShort: 'Type at least %{min} letters.',
    empty: 'No results for "%{query}"',
    emptyHint: 'Try fewer words or another way of saying it. They must all appear in the same section.',
    error: 'The manual could not be searched.',
    retry: 'Retry',
    count: '%{smart_count} result |||| %{smart_count} results',
    more: 'Showing the first %{shown} of %{total}. Add words to narrow it down.',
  },
  lang: {
    label: 'Manual language',
    es: 'ES',
    en: 'EN',
  },
  meta: {
    updated: 'Updated on %{date}',
  },
  staff: {
    label: 'Roommatik staff only',
    chapter: 'Chapter for Roommatik staff only',
  },
  state: {
    empty: 'The manual has no published chapters yet.',
    notFound: 'This chapter does not exist.',
    imageMissing: 'Image not available',
  },
  image: {
    enlarge: 'Open the image at full size',
  },
  help: {
    button: 'See in the manual',
    hint: 'Open the manual at the section that explains this screen',
  },
};
